import { render, staticRenderFns } from "./metrics.vue?vue&type=template&id=cd52c310&"
import script from "./metrics.vue?vue&type=script&lang=js&"
export * from "./metrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports